// This file is auto-generated by @hey-api/openapi-ts

import {
  createClient,
  createConfig,
  type Options,
  formDataBodySerializer,
} from "@hey-api/client-fetch";
import type {
  GetV1OrganizationsByOrganizationIdLeadsData,
  GetV1OrganizationsByOrganizationIdLeadsError,
  GetV1OrganizationsByOrganizationIdLeadsResponse,
  CreateLeadData,
  CreateLeadError,
  CreateLeadResponse,
  GetV1OrganizationsByOrganizationIdArchivedLeadsData,
  GetV1OrganizationsByOrganizationIdArchivedLeadsError,
  GetV1OrganizationsByOrganizationIdArchivedLeadsResponse,
  PostV1QueryAssignmentData,
  PostV1QueryAssignmentError,
  PostV1QueryAssignmentResponse,
  GetV1QueryClientInfoData,
  GetV1QueryClientInfoError,
  GetV1QueryClientInfoResponse,
  GetV1ProfilesError,
  GetV1ProfilesResponse,
  PostV1ProfilesData,
  PostV1ProfilesError,
  PostV1ProfilesResponse,
  GetV1ProfilesByProfileIdData,
  GetV1ProfilesByProfileIdError,
  GetV1ProfilesByProfileIdResponse,
  PutV1ProfilesByProfileIdData,
  PutV1ProfilesByProfileIdError,
  PutV1ProfilesByProfileIdResponse,
  DeleteV1ProfilesByProfileIdData,
  PostV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeData,
  PostV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeError,
  PostV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeResponse,
  GetV1OrganizationsByOrganizationIdData,
  GetV1OrganizationsByOrganizationIdError,
  GetV1OrganizationsByOrganizationIdResponse,
  PutV1OrganizationsByOrganizationIdData,
  PutV1OrganizationsByOrganizationIdError,
  PutV1OrganizationsByOrganizationIdResponse,
  GetV1OrganizationsInfoByOrganizationIdData,
  GetV1OrganizationsInfoByOrganizationIdError,
  GetV1OrganizationsInfoByOrganizationIdResponse,
  PutV1OrganizationsByOrganizationIdLeadsByLeadIdData,
  PutV1OrganizationsByOrganizationIdLeadsByLeadIdError,
  PutV1OrganizationsByOrganizationIdLeadsByLeadIdResponse,
  DeleteV1OrganizationsByOrganizationIdLeadsByLeadIdData,
  DeleteV1OrganizationsByOrganizationIdLeadsByLeadIdError,
  DeleteV1OrganizationsByOrganizationIdLeadsByLeadIdResponse,
  OptionsV1OrganizationsByOrganizationIdLeadsByLeadIdData,
  OptionsV1OrganizationsByOrganizationIdLeadsByLeadIdError,
  OptionsV1OrganizationsByOrganizationIdLeadsByLeadIdResponse,
  GetV1JobsData,
  GetV1JobsError,
  GetV1JobsResponse,
  GetV1MultipleJobsData,
  GetV1MultipleJobsError,
  GetV1MultipleJobsResponse,
  PutV1OrganizationsByOrganizationIdClientsByClientIdData,
  PutV1OrganizationsByOrganizationIdClientsByClientIdError,
  PutV1OrganizationsByOrganizationIdClientsByClientIdResponse,
  OptionsV1OrganizationsByOrganizationIdClientsByClientIdData,
  OptionsV1OrganizationsByOrganizationIdClientsByClientIdError,
  OptionsV1OrganizationsByOrganizationIdClientsByClientIdResponse,
  GetV2pByProfileLinkData,
  GetV2pByProfileLinkError,
  GetV2pByProfileLinkResponse,
  OptionsV2pByProfileLinkData,
  OptionsV2pByProfileLinkError,
  OptionsV2pByProfileLinkResponse,
  GetV1CommentsByResourceIdData,
  GetV1CommentsByResourceIdError,
  GetV1CommentsByResourceIdResponse,
  DeleteV1CommentsByResourceIdData,
  DeleteV1CommentsByResourceIdError,
  DeleteV1CommentsByResourceIdResponse,
  OptionsV1CommentsByResourceIdData,
  OptionsV1CommentsByResourceIdError,
  OptionsV1CommentsByResourceIdResponse,
  PostV1CommentsData,
  PostV1CommentsError,
  PostV1CommentsResponse,
  OptionsV1CommentsError,
  OptionsV1CommentsResponse,
  PostV1LeadsByLeadIdContractsData,
  PostV1LeadsByLeadIdContractsError,
  PostV1LeadsByLeadIdContractsResponse,
  OptionsV1LeadsByLeadIdContractsData,
  OptionsV1LeadsByLeadIdContractsError,
  OptionsV1LeadsByLeadIdContractsResponse,
  PutV1LeadsByLeadIdContractsByContractIdData,
  PutV1LeadsByLeadIdContractsByContractIdError,
  PutV1LeadsByLeadIdContractsByContractIdResponse,
  DeleteV1LeadsByLeadIdContractsByContractIdData,
  DeleteV1LeadsByLeadIdContractsByContractIdError,
  DeleteV1LeadsByLeadIdContractsByContractIdResponse,
  OptionsV1LeadsByLeadIdContractsByContractIdData,
  OptionsV1LeadsByLeadIdContractsByContractIdError,
  OptionsV1LeadsByLeadIdContractsByContractIdResponse,
  GetV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsData,
  GetV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsError,
  GetV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsResponse,
  OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsData,
  OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsError,
  OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsResponse,
  GetV1OrganizationsByOrganizationIdProfilesByProfileIdData,
  GetV1OrganizationsByOrganizationIdProfilesByProfileIdError,
  GetV1OrganizationsByOrganizationIdProfilesByProfileIdResponse,
  PutV1OrganizationsByOrganizationIdProfilesByProfileIdData,
  PutV1OrganizationsByOrganizationIdProfilesByProfileIdError,
  PutV1OrganizationsByOrganizationIdProfilesByProfileIdResponse,
  OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdData,
  OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdError,
  OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdResponse,
  PutV1OrganizationsByOrganizationIdProfilesByProfileIdEmailData,
  PutV1OrganizationsByOrganizationIdProfilesByProfileIdEmailError,
  PutV1OrganizationsByOrganizationIdProfilesByProfileIdEmailResponse,
  OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdEmailData,
  OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdEmailError,
  OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdEmailResponse,
  GetV1OrganizationsByOrganizationIdProfilesData,
  GetV1OrganizationsByOrganizationIdProfilesError,
  GetV1OrganizationsByOrganizationIdProfilesResponse,
  PostV1OrganizationsByOrganizationIdProfilesData,
  PostV1OrganizationsByOrganizationIdProfilesError,
  PostV1OrganizationsByOrganizationIdProfilesResponse,
  PostV2OrganizationsByOrganizationIdProfilesData,
  PostV2OrganizationsByOrganizationIdProfilesError,
  PostV2OrganizationsByOrganizationIdProfilesResponse,
  SearchSkillsData,
  SearchSkillsError,
  SearchSkillsResponse,
  GetV1OrganizationsByOrganizationIdSkillsData,
  GetV1OrganizationsByOrganizationIdSkillsError,
  GetV1OrganizationsByOrganizationIdSkillsResponse,
  OptionsV1OrganizationsByOrganizationIdSkillsData,
  OptionsV1OrganizationsByOrganizationIdSkillsError,
  OptionsV1OrganizationsByOrganizationIdSkillsResponse,
  GetV1OrganizationsByOrganizationIdMatchData,
  GetV1OrganizationsByOrganizationIdMatchError,
  GetV1OrganizationsByOrganizationIdMatchResponse,
  OptionsV1OrganizationsByOrganizationIdMatchData,
  OptionsV1OrganizationsByOrganizationIdMatchError,
  OptionsV1OrganizationsByOrganizationIdMatchResponse,
  GetV1OrganizationsByOrganizationIdProfilesByProfileIdMatchData,
  GetV1OrganizationsByOrganizationIdProfilesByProfileIdMatchError,
  GetV1OrganizationsByOrganizationIdProfilesByProfileIdMatchResponse,
  OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdMatchData,
  OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdMatchError,
  OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdMatchResponse,
  GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchData,
  GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchError,
  GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResponse,
  OptionsV1OrganizationsByOrganizationIdLeadsByLeadIdMatchData,
  OptionsV1OrganizationsByOrganizationIdLeadsByLeadIdMatchError,
  OptionsV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResponse,
  GetV1OrganizationByOrganizationIdContactData,
  GetV1OrganizationByOrganizationIdContactError,
  GetV1OrganizationByOrganizationIdContactResponse,
  OptionsV1OrganizationByOrganizationIdContactData,
  OptionsV1OrganizationByOrganizationIdContactError,
  OptionsV1OrganizationByOrganizationIdContactResponse,
  PutV1NotificationsByResourceIdData,
  PutV1NotificationsByResourceIdError,
  PutV1NotificationsByResourceIdResponse,
  OptionsV1NotificationsByResourceIdData,
  OptionsV1NotificationsByResourceIdError,
  OptionsV1NotificationsByResourceIdResponse,
  PostV1AssignmentData,
  PostV1AssignmentError,
  PostV1AssignmentResponse,
  OptionsV1AssignmentError,
  OptionsV1AssignmentResponse,
  PostV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateData,
  PostV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateError,
  PostV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateResponse,
  OptionsV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateError,
  OptionsV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateResponse,
  GetV1UsersError,
  GetV1UsersResponse,
  OptionsV1UsersError,
  OptionsV1UsersResponse,
  GetV1OrganisationsByOrganizationIdClientsData,
  GetV1OrganisationsByOrganizationIdClientsError,
  GetV1OrganisationsByOrganizationIdClientsResponse,
  PostV1OrganisationsByOrganizationIdClientsData,
  PostV1OrganisationsByOrganizationIdClientsError,
  PostV1OrganisationsByOrganizationIdClientsResponse,
  OptionsV1OrganisationsByOrganizationIdClientsData,
  OptionsV1OrganisationsByOrganizationIdClientsError,
  OptionsV1OrganisationsByOrganizationIdClientsResponse,
  PutV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentMotivationByLinkIdData,
  PutV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentMotivationByLinkIdError,
  PutV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentMotivationByLinkIdResponse,
  PostV1SkillsCategoriesData,
  PostV1SkillsCategoriesError,
  PostV1SkillsCategoriesResponse,
  OptionsV1SkillsCategoriesError,
  OptionsV1SkillsCategoriesResponse,
  GetV1LinksByProfileLinkData,
  GetV1LinksByProfileLinkError,
  GetV1LinksByProfileLinkResponse,
  PutV1LinksByProfileLinkData,
  PutV1LinksByProfileLinkError,
  PutV1LinksByProfileLinkResponse,
  GetV1LinksByProfileLinkSettingsData,
  GetV1LinksByProfileLinkSettingsError,
  GetV1LinksByProfileLinkSettingsResponse,
  GetV1LinksByProfileLinkWordData,
  GetV1LinksByProfileLinkWordError,
  GetV1LinksByProfileLinkWordResponse,
  PutV1LinksByProfileLinkResetData,
  PutV1LinksByProfileLinkResetError,
  PutV1LinksByProfileLinkResetResponse,
  PostV1LinksByProfileLinkContactsData,
  PostV1LinksByProfileLinkContactsError,
  PostV1LinksByProfileLinkContactsResponse,
  OptionsV1LinksByProfileLinkContactsError,
  OptionsV1LinksByProfileLinkContactsResponse,
  GetV1OrganizationsByOrganizationIdAssignmentsData,
  GetV1OrganizationsByOrganizationIdAssignmentsError,
  GetV1OrganizationsByOrganizationIdAssignmentsResponse,
  PostV1OrganizationsByOrganizationIdAssignmentsData,
  PostV1OrganizationsByOrganizationIdAssignmentsError,
  PostV1OrganizationsByOrganizationIdAssignmentsResponse,
  PutV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdData,
  PutV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdError,
  PutV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdResponse,
  DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdData,
  DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdError,
  DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdResponse,
  PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateData,
  PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateError,
  PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateResponse,
  PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadData,
  PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadError,
  PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadResponse,
  PostV1OrganizationsByOrganizationIdSemanticMatchData,
  PostV1OrganizationsByOrganizationIdSemanticMatchError,
  PostV1OrganizationsByOrganizationIdSemanticMatchResponse,
  GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchStreamData,
  GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchStreamError,
  GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchStreamResponse,
  GetV1OrganizationsByOrganizationIdActiveLeadJobsData,
  GetV1OrganizationsByOrganizationIdActiveLeadJobsError,
  GetV1OrganizationsByOrganizationIdActiveLeadJobsResponse,
  PostV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchData,
  PostV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchError,
  PostV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchResponse,
  GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResultsData,
  GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResultsError,
  GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResultsResponse,
} from "./types.gen";

export const client = createClient(createConfig());

/**
 * Get leads for an organization
 * Retrieve a list of leads associated with the specified organization.
 */
export const getV1OrganizationsByOrganizationIdLeads = <ThrowOnError extends boolean = false>(
  options: Options<GetV1OrganizationsByOrganizationIdLeadsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1OrganizationsByOrganizationIdLeadsResponse,
    GetV1OrganizationsByOrganizationIdLeadsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/leads",
  });
};

/**
 * Create a new lead
 * Creates a new lead for a specific organization
 */
export const createLead = <ThrowOnError extends boolean = false>(
  options: Options<CreateLeadData, ThrowOnError>
) => {
  return (options?.client ?? client).post<CreateLeadResponse, CreateLeadError, ThrowOnError>({
    ...options,
    url: "/v1/organizations/{organizationID}/leads",
  });
};

/**
 * Get archived leads for an organization
 * Retrieve a list of leads associated with the specified organization.
 */
export const getV1OrganizationsByOrganizationIdArchivedLeads = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetV1OrganizationsByOrganizationIdArchivedLeadsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1OrganizationsByOrganizationIdArchivedLeadsResponse,
    GetV1OrganizationsByOrganizationIdArchivedLeadsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/archived-leads",
  });
};

/**
 * Gather and compile assignment information based on a url or a text
 */
export const postV1QueryAssignment = <ThrowOnError extends boolean = false>(
  options: Options<PostV1QueryAssignmentData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostV1QueryAssignmentResponse,
    PostV1QueryAssignmentError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/query/assignment",
  });
};

/**
 * Fetch client information from a url
 */
export const getV1QueryClientInfo = <ThrowOnError extends boolean = false>(
  options: Options<GetV1QueryClientInfoData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1QueryClientInfoResponse,
    GetV1QueryClientInfoError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/query/client-info",
  });
};

/**
 * Get all profiles
 */
export const getV1Profiles = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<GetV1ProfilesResponse, GetV1ProfilesError, ThrowOnError>({
    ...options,
    url: "/v1/profiles",
  });
};

/**
 * Create a new profile
 */
export const postV1Profiles = <ThrowOnError extends boolean = false>(
  options: Options<PostV1ProfilesData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostV1ProfilesResponse,
    PostV1ProfilesError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/profiles",
  });
};

/**
 * Get a specific profile
 */
export const getV1ProfilesByProfileId = <ThrowOnError extends boolean = false>(
  options: Options<GetV1ProfilesByProfileIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1ProfilesByProfileIdResponse,
    GetV1ProfilesByProfileIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/profiles/{profileID}",
  });
};

/**
 * Update a profile
 */
export const putV1ProfilesByProfileId = <ThrowOnError extends boolean = false>(
  options: Options<PutV1ProfilesByProfileIdData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    PutV1ProfilesByProfileIdResponse,
    PutV1ProfilesByProfileIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/profiles/{profileID}",
  });
};

export const deleteV1ProfilesByProfileId = <ThrowOnError extends boolean = false>(
  options: Options<DeleteV1ProfilesByProfileIdData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<void, unknown, ThrowOnError>({
    ...options,
    url: "/v1/profiles/{profileID}",
  });
};

/**
 * Upload resume for profile
 * Upload a PDF resume file to parse and update profile data
 */
export const postV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResume = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeResponse,
    PostV1OrganizationsByOrganizationIdProfilesByProfileIdUploadResumeError,
    ThrowOnError
  >({
    ...options,
    ...formDataBodySerializer,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
    url: "/v1/organizations/{organizationID}/profiles/{profileID}/upload-resume",
  });
};

/**
 * Get organization overview
 */
export const getV1OrganizationsByOrganizationId = <ThrowOnError extends boolean = false>(
  options: Options<GetV1OrganizationsByOrganizationIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1OrganizationsByOrganizationIdResponse,
    GetV1OrganizationsByOrganizationIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}",
  });
};

/**
 * Update organization
 */
export const putV1OrganizationsByOrganizationId = <ThrowOnError extends boolean = false>(
  options: Options<PutV1OrganizationsByOrganizationIdData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    PutV1OrganizationsByOrganizationIdResponse,
    PutV1OrganizationsByOrganizationIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}",
  });
};

/**
 * Get organization info
 */
export const getV1OrganizationsInfoByOrganizationId = <ThrowOnError extends boolean = false>(
  options: Options<GetV1OrganizationsInfoByOrganizationIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1OrganizationsInfoByOrganizationIdResponse,
    GetV1OrganizationsInfoByOrganizationIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations-info/{organizationID}",
  });
};

/**
 * Update a lead
 * Update an existing lead for a specific organization
 */
export const putV1OrganizationsByOrganizationIdLeadsByLeadId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutV1OrganizationsByOrganizationIdLeadsByLeadIdData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    PutV1OrganizationsByOrganizationIdLeadsByLeadIdResponse,
    PutV1OrganizationsByOrganizationIdLeadsByLeadIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/leads/{leadID}",
  });
};

/**
 * Deletes a lead completely
 * Deletes a lead froms storage (leads needs to be archived first)
 */
export const deleteV1OrganizationsByOrganizationIdLeadsByLeadId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteV1OrganizationsByOrganizationIdLeadsByLeadIdData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteV1OrganizationsByOrganizationIdLeadsByLeadIdResponse,
    DeleteV1OrganizationsByOrganizationIdLeadsByLeadIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/leads/{leadID}",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1OrganizationsByOrganizationIdLeadsByLeadId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OptionsV1OrganizationsByOrganizationIdLeadsByLeadIdData, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1OrganizationsByOrganizationIdLeadsByLeadIdResponse,
    OptionsV1OrganizationsByOrganizationIdLeadsByLeadIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/leads/{leadID}",
  });
};

/**
 * Get background job
 */
export const getV1Jobs = <ThrowOnError extends boolean = false>(
  options: Options<GetV1JobsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<GetV1JobsResponse, GetV1JobsError, ThrowOnError>({
    ...options,
    url: "/v1/jobs",
  });
};

/**
 * Get background job
 */
export const getV1MultipleJobs = <ThrowOnError extends boolean = false>(
  options: Options<GetV1MultipleJobsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1MultipleJobsResponse,
    GetV1MultipleJobsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/multiple-jobs",
  });
};

/**
 * Update client
 * Update an existing client for a specific organization
 */
export const putV1OrganizationsByOrganizationIdClientsByClientId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutV1OrganizationsByOrganizationIdClientsByClientIdData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    PutV1OrganizationsByOrganizationIdClientsByClientIdResponse,
    PutV1OrganizationsByOrganizationIdClientsByClientIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/clients/{clientID}",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1OrganizationsByOrganizationIdClientsByClientId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OptionsV1OrganizationsByOrganizationIdClientsByClientIdData, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1OrganizationsByOrganizationIdClientsByClientIdResponse,
    OptionsV1OrganizationsByOrganizationIdClientsByClientIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/clients/{clientID}",
  });
};

/**
 * Get profile by link
 * Retrieves a profile using its unique link identifier
 */
export const getV2PByProfileLink = <ThrowOnError extends boolean = false>(
  options: Options<GetV2pByProfileLinkData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV2pByProfileLinkResponse,
    GetV2pByProfileLinkError,
    ThrowOnError
  >({
    ...options,
    url: "/v2/p/{profileLink}",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV2PByProfileLink = <ThrowOnError extends boolean = false>(
  options: Options<OptionsV2pByProfileLinkData, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV2pByProfileLinkResponse,
    OptionsV2pByProfileLinkError,
    ThrowOnError
  >({
    ...options,
    url: "/v2/p/{profileLink}",
  });
};

/**
 * Get resource comments
 * Retrieve comments for a specific resource
 */
export const getV1CommentsByResourceId = <ThrowOnError extends boolean = false>(
  options: Options<GetV1CommentsByResourceIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1CommentsByResourceIdResponse,
    GetV1CommentsByResourceIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/comments/{resourceID}",
  });
};

/**
 * Delete resource comment
 * Delete a comment for a specific resource
 */
export const deleteV1CommentsByResourceId = <ThrowOnError extends boolean = false>(
  options: Options<DeleteV1CommentsByResourceIdData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteV1CommentsByResourceIdResponse,
    DeleteV1CommentsByResourceIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/comments/{resourceID}",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1CommentsByResourceId = <ThrowOnError extends boolean = false>(
  options: Options<OptionsV1CommentsByResourceIdData, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1CommentsByResourceIdResponse,
    OptionsV1CommentsByResourceIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/comments/{resourceID}",
  });
};

/**
 * Create resource comment
 * Create a new comment for a resource
 */
export const postV1Comments = <ThrowOnError extends boolean = false>(
  options: Options<PostV1CommentsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostV1CommentsResponse,
    PostV1CommentsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/comments",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1Comments = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1CommentsResponse,
    OptionsV1CommentsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/comments",
  });
};

/**
 * Create contract for a lead
 * Create a new contract associated with a specific lead
 */
export const postV1LeadsByLeadIdContracts = <ThrowOnError extends boolean = false>(
  options: Options<PostV1LeadsByLeadIdContractsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostV1LeadsByLeadIdContractsResponse,
    PostV1LeadsByLeadIdContractsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/leads/{leadID}/contracts",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1LeadsByLeadIdContracts = <ThrowOnError extends boolean = false>(
  options: Options<OptionsV1LeadsByLeadIdContractsData, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1LeadsByLeadIdContractsResponse,
    OptionsV1LeadsByLeadIdContractsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/leads/{leadID}/contracts",
  });
};

/**
 * Update contract
 * Update a contract connected to a lead
 */
export const putV1LeadsByLeadIdContractsByContractId = <ThrowOnError extends boolean = false>(
  options: Options<PutV1LeadsByLeadIdContractsByContractIdData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    PutV1LeadsByLeadIdContractsByContractIdResponse,
    PutV1LeadsByLeadIdContractsByContractIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/leads/{leadID}/contracts/{contractID}",
  });
};

/**
 * Delete contract from a lead
 * Delete a contract
 */
export const deleteV1LeadsByLeadIdContractsByContractId = <ThrowOnError extends boolean = false>(
  options: Options<DeleteV1LeadsByLeadIdContractsByContractIdData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteV1LeadsByLeadIdContractsByContractIdResponse,
    DeleteV1LeadsByLeadIdContractsByContractIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/leads/{leadID}/contracts/{contractID}",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1LeadsByLeadIdContractsByContractId = <ThrowOnError extends boolean = false>(
  options: Options<OptionsV1LeadsByLeadIdContractsByContractIdData, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1LeadsByLeadIdContractsByContractIdResponse,
    OptionsV1LeadsByLeadIdContractsByContractIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/leads/{leadID}/contracts/{contractID}",
  });
};

/**
 * Get organization profile leads
 * Retrieve detailed profile leads information
 */
export const getV1OrganizationsByOrganizationIdProfilesByProfileIdLeads = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsResponse,
    GetV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/profiles/{profileID}/leads",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1OrganizationsByOrganizationIdProfilesByProfileIdLeads = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsData, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsResponse,
    OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdLeadsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/profiles/{profileID}/leads",
  });
};

/**
 * Get organization profile details
 * Retrieve detailed profile information within an organization context
 */
export const getV1OrganizationsByOrganizationIdProfilesByProfileId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetV1OrganizationsByOrganizationIdProfilesByProfileIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1OrganizationsByOrganizationIdProfilesByProfileIdResponse,
    GetV1OrganizationsByOrganizationIdProfilesByProfileIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/profiles/{profileID}",
  });
};

/**
 * Update organization profile
 * Update profile information within an organization context
 */
export const putV1OrganizationsByOrganizationIdProfilesByProfileId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutV1OrganizationsByOrganizationIdProfilesByProfileIdData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    PutV1OrganizationsByOrganizationIdProfilesByProfileIdResponse,
    PutV1OrganizationsByOrganizationIdProfilesByProfileIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/profiles/{profileID}",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1OrganizationsByOrganizationIdProfilesByProfileId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdData, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdResponse,
    OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/profiles/{profileID}",
  });
};

/**
 * Update organization profile email
 * Update the email address for a profile within an organization
 */
export const putV1OrganizationsByOrganizationIdProfilesByProfileIdEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutV1OrganizationsByOrganizationIdProfilesByProfileIdEmailData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    PutV1OrganizationsByOrganizationIdProfilesByProfileIdEmailResponse,
    PutV1OrganizationsByOrganizationIdProfilesByProfileIdEmailError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/profiles/{profileID}/email",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1OrganizationsByOrganizationIdProfilesByProfileIdEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdEmailData, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdEmailResponse,
    OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdEmailError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/profiles/{profileID}/email",
  });
};

/**
 * Get the profiles of the organization members
 */
export const getV1OrganizationsByOrganizationIdProfiles = <ThrowOnError extends boolean = false>(
  options: Options<GetV1OrganizationsByOrganizationIdProfilesData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1OrganizationsByOrganizationIdProfilesResponse,
    GetV1OrganizationsByOrganizationIdProfilesError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/profiles",
  });
};

/**
 * Invite a profile to an organization
 * Invites a profile to join the specified organization
 */
export const postV1OrganizationsByOrganizationIdProfiles = <ThrowOnError extends boolean = false>(
  options: Options<PostV1OrganizationsByOrganizationIdProfilesData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostV1OrganizationsByOrganizationIdProfilesResponse,
    PostV1OrganizationsByOrganizationIdProfilesError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/profiles",
  });
};

/**
 * Create a random profile and invite to organization
 * Creates a new profile with random email and adds it to the specified organization
 */
export const postV2OrganizationsByOrganizationIdProfiles = <ThrowOnError extends boolean = false>(
  options: Options<PostV2OrganizationsByOrganizationIdProfilesData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostV2OrganizationsByOrganizationIdProfilesResponse,
    PostV2OrganizationsByOrganizationIdProfilesError,
    ThrowOnError
  >({
    ...options,
    url: "/v2/organizations/{organizationID}/profiles",
  });
};

/**
 * Search for skills by name or alternate spellings
 * Returns a list of skills that match the search term in either the name or alternate spellings
 */
export const searchSkills = <ThrowOnError extends boolean = false>(
  options: Options<SearchSkillsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<SearchSkillsResponse, SearchSkillsError, ThrowOnError>({
    ...options,
    url: "/v1/skills/search",
  });
};

/**
 * Get organization skills
 * Retrieve a list of skills associated with a specific organization
 */
export const getV1OrganizationsByOrganizationIdSkills = <ThrowOnError extends boolean = false>(
  options: Options<GetV1OrganizationsByOrganizationIdSkillsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1OrganizationsByOrganizationIdSkillsResponse,
    GetV1OrganizationsByOrganizationIdSkillsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/skills",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1OrganizationsByOrganizationIdSkills = <ThrowOnError extends boolean = false>(
  options: Options<OptionsV1OrganizationsByOrganizationIdSkillsData, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1OrganizationsByOrganizationIdSkillsResponse,
    OptionsV1OrganizationsByOrganizationIdSkillsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/skills",
  });
};

/**
 * Get organization skills
 * Retrieve a list of skills associated with a specific organization
 */
export const getV1OrganizationsByOrganizationIdMatch = <ThrowOnError extends boolean = false>(
  options: Options<GetV1OrganizationsByOrganizationIdMatchData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1OrganizationsByOrganizationIdMatchResponse,
    GetV1OrganizationsByOrganizationIdMatchError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/match",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1OrganizationsByOrganizationIdMatch = <ThrowOnError extends boolean = false>(
  options: Options<OptionsV1OrganizationsByOrganizationIdMatchData, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1OrganizationsByOrganizationIdMatchResponse,
    OptionsV1OrganizationsByOrganizationIdMatchError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/match",
  });
};

/**
 * Get profile matching skills
 * Retrieve a list of skills associated with a specific organization
 */
export const getV1OrganizationsByOrganizationIdProfilesByProfileIdMatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetV1OrganizationsByOrganizationIdProfilesByProfileIdMatchData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1OrganizationsByOrganizationIdProfilesByProfileIdMatchResponse,
    GetV1OrganizationsByOrganizationIdProfilesByProfileIdMatchError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/profiles/{profileID}/match",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1OrganizationsByOrganizationIdProfilesByProfileIdMatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdMatchData, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdMatchResponse,
    OptionsV1OrganizationsByOrganizationIdProfilesByProfileIdMatchError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/profiles/{profileID}/match",
  });
};

/**
 * Get organization skills
 * Retrieve a list of skills associated with a specific organization
 */
export const getV1OrganizationsByOrganizationIdLeadsByLeadIdMatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResponse,
    GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/leads/{leadID}/match",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1OrganizationsByOrganizationIdLeadsByLeadIdMatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OptionsV1OrganizationsByOrganizationIdLeadsByLeadIdMatchData, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResponse,
    OptionsV1OrganizationsByOrganizationIdLeadsByLeadIdMatchError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/leads/{leadID}/match",
  });
};

/**
 * Get organization contact info
 * Retrive contact info for the organization
 */
export const getV1OrganizationByOrganizationIdContact = <ThrowOnError extends boolean = false>(
  options: Options<GetV1OrganizationByOrganizationIdContactData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1OrganizationByOrganizationIdContactResponse,
    GetV1OrganizationByOrganizationIdContactError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organization/{organizationID}/contact",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1OrganizationByOrganizationIdContact = <ThrowOnError extends boolean = false>(
  options: Options<OptionsV1OrganizationByOrganizationIdContactData, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1OrganizationByOrganizationIdContactResponse,
    OptionsV1OrganizationByOrganizationIdContactError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organization/{organizationID}/contact",
  });
};

/**
 * Reset resource notification
 * Reset the notification status for a specific resource
 */
export const putV1NotificationsByResourceId = <ThrowOnError extends boolean = false>(
  options: Options<PutV1NotificationsByResourceIdData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    PutV1NotificationsByResourceIdResponse,
    PutV1NotificationsByResourceIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/notifications/{resourceID}",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1NotificationsByResourceId = <ThrowOnError extends boolean = false>(
  options: Options<OptionsV1NotificationsByResourceIdData, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1NotificationsByResourceIdResponse,
    OptionsV1NotificationsByResourceIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/notifications/{resourceID}",
  });
};

/**
 * Get assignment information
 * Retrieve information about an assignment based on provided details
 */
export const postV1Assignment = <ThrowOnError extends boolean = false>(
  options: Options<PostV1AssignmentData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostV1AssignmentResponse,
    PostV1AssignmentError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/assignment",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1Assignment = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1AssignmentResponse,
    OptionsV1AssignmentError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/assignment",
  });
};

/**
 * Generate assignment information using AI
 * Parse and extract structured information from a job assignment description using AI agent and save it to the specified lead
 */
export const postV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateResponse,
    PostV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/leads/{leadID}/assignment/generate",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerate = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateResponse,
    OptionsV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentGenerateError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/leads/{leadID}/assignment/generate",
  });
};

/**
 * Get User Settings
 * Retrieve the settings for the authenticated user
 */
export const getV1Users = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<GetV1UsersResponse, GetV1UsersError, ThrowOnError>({
    ...options,
    url: "/v1/users",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1Users = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1UsersResponse,
    OptionsV1UsersError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/users",
  });
};

/**
 * Get clients for an organization
 * Retrieves a list of clients with their contact information for the specified organization
 */
export const getV1OrganisationsByOrganizationIdClients = <ThrowOnError extends boolean = false>(
  options: Options<GetV1OrganisationsByOrganizationIdClientsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1OrganisationsByOrganizationIdClientsResponse,
    GetV1OrganisationsByOrganizationIdClientsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organisations/{organizationID}/clients",
  });
};

/**
 * Create client
 * Create a new client for a specific organization
 */
export const postV1OrganisationsByOrganizationIdClients = <ThrowOnError extends boolean = false>(
  options: Options<PostV1OrganisationsByOrganizationIdClientsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostV1OrganisationsByOrganizationIdClientsResponse,
    PostV1OrganisationsByOrganizationIdClientsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organisations/{organizationID}/clients",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1OrganisationsByOrganizationIdClients = <ThrowOnError extends boolean = false>(
  options: Options<OptionsV1OrganisationsByOrganizationIdClientsData, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1OrganisationsByOrganizationIdClientsResponse,
    OptionsV1OrganisationsByOrganizationIdClientsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organisations/{organizationID}/clients",
  });
};

/**
 * Query LLM´s for a motivation why the profile fits the assigment
 * Query LLM´s for a motivation why the profile fits the assigment
 */
export const putV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentMotivationByLinkId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentMotivationByLinkIdData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).put<
    PutV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentMotivationByLinkIdResponse,
    PutV1OrganizationsByOrganizationIdLeadsByLeadIdAssignmentMotivationByLinkIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/leads/{leadID}/assignment-motivation/{linkID}",
  });
};

/**
 * Get categories for multiple skills
 * Returns main category and sub category for each provided skill name
 */
export const postV1SkillsCategories = <ThrowOnError extends boolean = false>(
  options: Options<PostV1SkillsCategoriesData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostV1SkillsCategoriesResponse,
    PostV1SkillsCategoriesError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/skills/categories",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1SkillsCategories = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1SkillsCategoriesResponse,
    OptionsV1SkillsCategoriesError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/skills/categories",
  });
};

/**
 * Get full profile by link
 * Retrieves the full profile information associated with a given profile link
 */
export const getV1LinksByProfileLink = <ThrowOnError extends boolean = false>(
  options: Options<GetV1LinksByProfileLinkData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1LinksByProfileLinkResponse,
    GetV1LinksByProfileLinkError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/links/{profileLink}",
  });
};

/**
 * Update profile link configuration
 * Updates the configuration of a specific profile link
 */
export const putV1LinksByProfileLink = <ThrowOnError extends boolean = false>(
  options: Options<PutV1LinksByProfileLinkData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    PutV1LinksByProfileLinkResponse,
    PutV1LinksByProfileLinkError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/links/{profileLink}",
  });
};

/**
 * Get profile link options
 * Retrieves the options of a specific profile link
 */
export const getV1LinksByProfileLinkSettings = <ThrowOnError extends boolean = false>(
  options: Options<GetV1LinksByProfileLinkSettingsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1LinksByProfileLinkSettingsResponse,
    GetV1LinksByProfileLinkSettingsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/links/{profileLink}/settings",
  });
};

/**
 * Get profile link as word doc
 * Get profile link as word doc
 */
export const getV1LinksByProfileLinkWord = <ThrowOnError extends boolean = false>(
  options: Options<GetV1LinksByProfileLinkWordData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1LinksByProfileLinkWordResponse,
    GetV1LinksByProfileLinkWordError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/links/{profileLink}/word",
  });
};

/**
 * Reset profile link
 * Resets the profile link settings
 */
export const putV1LinksByProfileLinkReset = <ThrowOnError extends boolean = false>(
  options: Options<PutV1LinksByProfileLinkResetData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    PutV1LinksByProfileLinkResetResponse,
    PutV1LinksByProfileLinkResetError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/links/{profileLink}/reset",
  });
};

/**
 * Create profile link contact
 * Creates a new profile link contact for a specific profile link
 */
export const postV1LinksByProfileLinkContacts = <ThrowOnError extends boolean = false>(
  options: Options<PostV1LinksByProfileLinkContactsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostV1LinksByProfileLinkContactsResponse,
    PostV1LinksByProfileLinkContactsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/links/{profileLink}/contacts",
  });
};

/**
 * CORS support
 * Enable CORS by returning correct headers
 */
export const optionsV1LinksByProfileLinkContacts = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).options<
    OptionsV1LinksByProfileLinkContactsResponse,
    OptionsV1LinksByProfileLinkContactsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/links/{profileLink}/contacts",
  });
};

/**
 * List assignments for an organization
 */
export const getV1OrganizationsByOrganizationIdAssignments = <ThrowOnError extends boolean = false>(
  options: Options<GetV1OrganizationsByOrganizationIdAssignmentsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1OrganizationsByOrganizationIdAssignmentsResponse,
    GetV1OrganizationsByOrganizationIdAssignmentsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/assignments",
  });
};

/**
 * Create a new assignment
 */
export const postV1OrganizationsByOrganizationIdAssignments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostV1OrganizationsByOrganizationIdAssignmentsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostV1OrganizationsByOrganizationIdAssignmentsResponse,
    PostV1OrganizationsByOrganizationIdAssignmentsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/assignments",
  });
};

/**
 * Update an assignment
 */
export const putV1OrganizationsByOrganizationIdAssignmentsByAssignmentId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    PutV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdResponse,
    PutV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/assignments/{assignmentID}",
  });
};

/**
 * Delete an assignment
 */
export const deleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdResponse,
    DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/assignments/{assignmentID}",
  });
};

/**
 * AI-parse assignment from URL or text
 */
export const postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateResponse,
    PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdGenerateError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/assignments/{assignmentID}/generate",
  });
};

/**
 * Create a lead from an assignment
 */
export const postV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLead = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadResponse,
    PostV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdLeadError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/assignments/{assignmentID}/lead",
  });
};

/**
 * Start a background semantic match job
 * Starts a background matching job and returns a jobId immediately. Subscribe to progress via GET /leads/{leadID}/match-stream.
 */
export const postV1OrganizationsByOrganizationIdSemanticMatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostV1OrganizationsByOrganizationIdSemanticMatchData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostV1OrganizationsByOrganizationIdSemanticMatchResponse,
    PostV1OrganizationsByOrganizationIdSemanticMatchError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/semantic-match",
  });
};

/**
 * Stream match job progress via SSE
 * Subscribe to SSE events for an active semantic match job. Emits progress_sync, embedding_done, profile_scored, and complete events.
 */
export const getV1OrganizationsByOrganizationIdLeadsByLeadIdMatchStream = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchStreamData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchStreamResponse,
    GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchStreamError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/leads/{leadID}/match-stream",
  });
};

/**
 * Get active lead jobs for the organization
 * Returns all active assignment-reader and semantic-match jobs for the org.
 */
export const getV1OrganizationsByOrganizationIdActiveLeadJobs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetV1OrganizationsByOrganizationIdActiveLeadJobsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1OrganizationsByOrganizationIdActiveLeadJobsResponse,
    GetV1OrganizationsByOrganizationIdActiveLeadJobsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/active-lead-jobs",
  });
};

/**
 * Semantic match a single profile against an assignment
 * Returns a single profile's semantic match result against an assignment.
 */
export const postV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchResponse,
    PostV1OrganizationsByOrganizationIdProfilesByProfileIdSemanticMatchError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/profiles/{profileID}/semantic-match",
  });
};

/**
 * Get stored match results for a lead
 * Retrieve previously computed semantic match results for a lead.
 */
export const getV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResults = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResultsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResultsResponse,
    GetV1OrganizationsByOrganizationIdLeadsByLeadIdMatchResultsError,
    ThrowOnError
  >({
    ...options,
    url: "/v1/organizations/{organizationID}/leads/{leadID}/match-results",
  });
};
